const SAFE_SCHEMES = ['http:', 'https:', 'mailto:']

/**
 * Filter a link's scheme before it reaches the DOM.
 *
 * Second line of defence; the parser filters too. Document text is written by
 * agents, so `javascript:`, `data:` and `vbscript:` hrefs are exactly the
 * payload this has to refuse. Returning null means the caller renders the text
 * without a link rather than a link that does nothing, so nothing invites a
 * click. BUG-006.
 *
 * This is a security control. It is unit-tested in safe.test.ts; if you change
 * it, change the test in the same commit.
 */
export function safeHref(raw: unknown): string | null {
  const candidate = String(raw || '').trim()
  if (!candidate) return null
  if (/^[/#?]/.test(candidate)) return candidate
  try {
    return SAFE_SCHEMES.includes(new URL(candidate, location.origin).protocol) ? candidate : null
  } catch {
    return null
  }
}

/**
 * Where to land after signing in.
 *
 * Only a same-origin *path* is honoured. `//evil.example` and
 * `https://evil.example` are both valid values to assign to location.href, and
 * an open redirect on a login page is how a phishing page borrows your domain.
 * Anything that is not a single-slash path falls back to '/'.
 */
export function safeNextPath(raw: string | null): string {
  if (!raw) return '/'
  if (raw[0] !== '/' || raw[1] === '/' || raw[1] === '\\') return '/'
  return raw
}
